PJQ.views.projects.MyProjectListDataTable = PJQ.views.dataTables.DataTable.extend({
	defaults: {
		subTemplates: {
			header: new PJQ.templating.Template(PJQ.constants.modules.PROJECTLIST, 'Data-Table-Header-Project-List')
		},
		language: {
			zeroRecords: "You haven't created any projects yet"
		},
		onGoToProject: _.noop,
		onUploadRevision: _.noop,
		onChangeReport: _.noop,
		onArchive: _.noop,
		onDelete: _.noop,
		onRecycle: _.noop,
		onRestore: _.noop,
		settings: null
	},
	events: {
		'keyup .datatable-search': 'search',
		'click .project-list-clear-filters': 'clearFilters',
		'change .project-list-favorite-filter': 'favoriteFilter'
	},
	beforeDataTableRender: function () {
		this.options.scrollRows = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DATA_TABLE_FIXED_HEADER);

		this.options.canAdd = PJQ.app.session.hasPermission('projects.canAdd') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_HOME_READONLY);
		this.options.isAdmin = PJQ.app.session.hasPermission('projects.isAdmin');

		if (this.options.isAdmin) {
			this.projectStatusSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('select.project-list-status-filter'),
				defaultValue: this.options.collection.options.status != null ? this.options.collection.options.status : 'ready',
				isMultiple: false,
				onChange: _.bind(function () {
					this.statusFilterChanged();
				}, this)
			});
		}
	},
	afterDataTableRender: function () {
		this.renderSubTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTLIST, 'Project-Commands'), this.$('div.project-list-buttons'), {
			canAdd: this.options.canAdd,
			isAdmin: this.options.isAdmin
		});
		this.$('input.project-list-favorite-filter').prop('checked', this.options.settings.get('isFavoriteFilter'));

		this.addContextMenu({
			actions: [
				{
					name: 'Go to Project',
					iconClass: 'fal fa-arrow-alt-from-left',
					onClick: _.bind(this.options.onGoToProject, this),
					isShown: _.bind(function (row) {
						let project = row.data();
						return (project.attributes.status === 'READY' || project.attributes.status === 'BUSY' || project.attributes.status === 'HIDDEN' || project.attributes.status === 'ARCHIVE');
					}, this)
				},
				{
					name: 'Upload Revision',
					iconClass: 'fal fa-cloud-upload',
					onClick: _.bind(this.options.onUploadRevision, this),
					isShown: _.bind(function (row) {
						let project = row.data();
						return this.options.isAdmin && (PJQ.app.session.get('masterUserId') === project.attributes.masterUserId) && (project.attributes.status === 'READY' || project.attributes.status === 'BUSY' || project.attributes.status === 'HIDDEN');
					}, this)
				},
				{
					name: 'Change Report',
					iconClass: 'fal fa-file',
					onClick: _.bind(this.options.onChangeReport, this),
					isShown: _.bind(function (row) {
						let project = row.data();
						return this.options.isAdmin && (PJQ.app.session.get('masterUserId') === project.attributes.masterUserId) && (project.attributes.status === 'READY' || project.attributes.status === 'BUSY' || project.attributes.status === 'HIDDEN' || project.attributes.status === 'ARCHIVE');
					}, this)
				},
				{
					name: 'Archive',
					iconClass: 'fal fa-archive',
					onClick: _.bind(this.options.onArchive, this),
					isShown: _.bind(function (row) {
						let project = row.data();
						return this.options.isAdmin && (PJQ.app.session.get('masterUserId') === project.attributes.masterUserId) && (project.attributes.status === 'READY' || project.attributes.status === 'BUSY' || project.attributes.status === 'HIDDEN');
					}, this)
				},
				{
					name: 'Restore',
					iconClass: 'fal fa-redo',
					onClick: _.bind(this.options.onRestore, this),
					isShown: _.bind(function (row) {
						let project = row.data();
						return this.options.isAdmin && (PJQ.app.session.get('masterUserId') === project.attributes.masterUserId) && (project.attributes.status === 'ARCHIVE' || project.attributes.status === 'DELETED');
					}, this)
				},
				{
					name: 'Recycle Bin',
					iconClass: 'fal fa-trash',
					isDanger: true,
					onClick: _.bind(this.options.onRecycle, this),
					isShown: _.bind(function (row) {
						let project = row.data();
						return this.options.isAdmin && (PJQ.app.session.get('masterUserId') === project.attributes.masterUserId) && (project.attributes.status === 'READY' || project.attributes.status === 'BUSY' || project.attributes.status === 'HIDDEN' || project.attributes.status === 'ARCHIVE');
					}, this)
				},
				{
					name: 'Delete',
					iconClass: 'fal fa-trash',
					isDanger: true,
					onClick: _.bind(this.options.onDelete, this),
					isShown: _.bind(function (row) {
						let project = row.data();
						return this.options.isAdmin && (PJQ.app.session.get('masterUserId') === project.attributes.masterUserId) && (project.attributes.status === 'DELETED');
					}, this)
				}
			]
		});
	},
	getFilterData: function () {
		if (!this.getFavoriteFilter()) {
			return this.options.collection.models;
		}

		return _.filter(this.options.collection.models, function (row) {
			return row.attributes.isFavorite;
		}, this);
	},
	afterSearch: function () {
		//this.$('.project-selector-clear-filters').prop('disabled', _.size(this.$('input.datatable-search').val()) === 0 && _.size(this.projectStatusFilter) === 0);
	},
	favoriteFilter: function () {
		this.options.settings.set('isFavoriteFilter', this.$('input.project-list-favorite-filter').prop('checked'));
		this.options.settings.save();
		this.filter();
	},
	getFavoriteFilter: function () {
		return this.options.settings.get('isFavoriteFilter'); //this.$('input.project-list-favorite-filter').prop('checked');
	},
	getStatusFilter: function () {
		return this.projectStatusSelectPicker.getValue();
	},
	statusFilterChanged: function () {
		this.options.collection.options.isSimple = false;
		this.options.collection.options.status = this.getStatusFilter();

		if (this.options.collection.options.status === 'ready') {
			this.$('a.archive-projects').show();
			this.$('a.restore-projects').hide();
		}
		else {
			this.$('a.archive-projects').hide();
			this.$('a.restore-projects').show();
		}

		let loader = new PJQ.Loader(this.$el.parent());
		this.options.collection.fetch({
			success: _.bind(function () {
				this.dataTable.clear();
				this.dataTable.rows.add(this.collection.models);
				this.filter();
				//this.dataTable.draw();
				loader.remove();
			}, this)
		});
	},
	clearFilters: function () {
		this.$('input.datatable-search').val('');
		this.$('input.project-list-favorite-filter').prop('checked', false);
		this.options.settings.set('isFavoriteFilter', false);
		this.options.settings.save();

		this.filter();
	},
	getRowGroup: function (row, groupBy) {
		if (groupBy === null)
			return null;

		let fieldValue = row.get(groupBy);
		if (groupBy === 'bidsDue') {
			if (row.attributes.rDueText === 'ASAP')
				fieldValue = row.attributes.rDueText;
			else if (row.attributes.bidsDue == null)
				fieldValue = "N/A";
			else
				fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.bidsDue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
		}
		else if (groupBy === 'userDisplayName') {
			fieldValue = (row.attributes.user && row.attributes.user.displayName) ? row.attributes.user.displayName : '';
		}
		else if (groupBy === 'user2DisplayName') {
			fieldValue = (row.attributes.user2 && row.attributes.user2.displayName) ? row.attributes.user2.displayName : '';
		}
		else if (groupBy === 'projectStatusId') {
			fieldValue = PJQ.app.session.projectStatuses.get(row.attributes.projectStatusId).get('name');
		}
		else if (groupBy === 'startDate') {
			fieldValue = row.attributes.startDate ? PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.startDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
		}
		else if (groupBy === 'endDate') {
			fieldValue = row.attributes.endDate ? PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.endDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
		}
		else if (groupBy.startsWith('fieldValue')) {
			_.each(PJQ.app.session.customFields.project[PJQ.app.session.get("masterUserId")].models, _.bind(function (customField) {
				// todo: only show the ones the user wants to.
				if (groupBy === 'fieldValue' + customField.get('fieldNumber')) {
					fieldValue = row.getCustomFieldValue(customField.get('id'));
					fieldValue = fieldValue ? fieldValue : '';
					switch (customField.get('fieldType')) {
						case PJQ.constants.customFields.fieldTypes.DATE:
							if (fieldValue) {
								fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
							}
							if (fieldValue === undefined)
								fieldValue = '';
							break;
						case PJQ.constants.customFields.fieldTypes.DATETIME:
							if (fieldValue) {
								fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_PROJECT_WALL) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.NEW_APP_PORTAL));
							}
							if (fieldValue === undefined)
								fieldValue = '';
							break;
						case PJQ.constants.customFields.fieldTypes.BOOL:
							if (fieldValue != null)
								fieldValue = fieldValue ? 'Yes' : 'No';
							else
								fieldValue = '';
							break;
						case PJQ.constants.customFields.fieldTypes.CHOICE:
							if (fieldValue) {
								let choices = [];

								// convert single choice value into array so that the logic below can work for both types.
								if (typeof fieldValue === 'number')
									fieldValue = [fieldValue];

								_.each(customField.choices.models, _.bind(function (choice) {
									if (_.find(fieldValue, function (value) {
										return value === choice.get('id');
									}))
										choices.push(choice.get('choiceName'));
								}, this));

								fieldValue = choices.join((', '));
							}
							break;
						case PJQ.constants.customFields.fieldTypes.MONEY:
							if (type === 'sort' || type === 'type') {
								if (fieldValue && fieldValue !== '$')
									fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
								else
									fieldValue = 0;

							}
							else {
								fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
							}
							break;
						case PJQ.constants.customFields.fieldTypes.INT:
							if (type !== 'sort' && type !== 'type' && fieldValue) {
								fieldValue = parseInt(fieldValue).toLocaleString();
							}
							break;
					}
				}
			}, this));
		}
		return fieldValue ? fieldValue : 'N/A';
	},

});

PJQ.views.projects.MyProjectList = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTLIST, 'Project-List')
	},
	events: {
		'click .btn-new-project': 'newProject',
		'click .btn-edit-project': 'editProjectButton',
		'click .btn-archive-project': 'archiveProjectButton',
		'click .archive-projects': 'multipleProjectActionInitialize',
		'click .btn-restore-project': 'restoreProjectButton',
		'click .restore-projects': 'multipleProjectActionInitialize',
		'click .btn-recycle-project': 'recycleProjectButton',
		'click .btn-delete-project': 'deleteProjectButton',
		'click .delete-projects': 'multipleProjectActionInitialize',
		'click .btn-favorite-project': 'favoriteProject',
		'click .invite-projects': 'multipleProjectActionInitialize',
		'click .projects-action-cancel': 'multipleProjectActionCancel',
		'change .select-project': 'multipleProjectSelection',
		'click .projects-action-confirm': 'multipleProjectActionConfirm',
		'click .btn-project-list-settings': 'settings'
	},
	beforeFirstRender: async function () {
		this.isFetched = false;

		this.options.canAdd = PJQ.app.session.hasPermission('projects.canAdd');
		this.options.isAdmin = PJQ.app.session.hasPermission('projects.isAdmin');

		this.settings = new PJQ.models.projects.ProjectSettings();
		await this.settings.fetch();

		await PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get("masterUserId"));

		this.collection = new PJQ.collections.projects.Projects(null, {
			isSimple: false,
			status: 'ready',
			isMyProjects: true,
			customFieldIds: this.getVisibleCustomFieldIds()
		});
		await this.collection.fetch();

		this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
		if (this.erpIntegration != null) {
			let erpObjects;
			try {
				erpObjects = await this.erpIntegration.fetchLinkedProjects();
			} catch {
				erpObjects = null;
			}
			if (erpObjects != null) {
				_.each(erpObjects, (obj) => {
					let project = this.collection.get(obj.internalId);
					if (project != null) {
						project.set('externalObject', obj);
					}
				});
			}
		}

		await PJQ.app.session.fetchProjectMessageEmailTemplates();
		await PJQ.app.session.fetchProjectStatuses();

		this.isFetched = true;
		this.render();
	},
	beforeRender: function () {
		this.renderData = {
			isFetched: this.isFetched
		};
		this.isMultipleProjectSelectMode = false;
		this.selectedProjects = [];
	},
	afterRender: function () {
		if (!this.isFetched) {
			this.loader = new PJQ.Loader(this.$el);
		}
		else {
			if (this.loader) {
				this.loader.remove();
				this.loader = null;
			}

			this.collapsedGroups = [];

			let dataTableOptions = {
				subTemplates: {
					header: new PJQ.templating.Template(PJQ.constants.modules.PROJECTLIST, 'Data-Table-Header-Project-List')
				},
				headerData: {
					isAdmin: this.options.isAdmin
				},
				el: this.$('.project-list'),
				collection: this.collection,
				data: this.collection.models,
				deferRender: true,
				colReorder: {
					fixedColumnsLeft: 2,
					fixedColumnsRight: 1,
					realtime: false
				},
				orderFixed: [[0, 'desc']],
				columnDefs: [{orderable: false, target: 0}],
				columns: this.getColumns(false),
				customFieldIds: this.getVisibleCustomFieldIds(),
				pageLength: this.settings.get('rowsPerPage'),
				dom: '<"top"<"project-list-buttons"><"project-list-buttons-right">p>rt<"bottom"p<"clear">>',
				onRowDoubleClick: _.bind(function (row) {
					if (this.collection.options.status === 'ready' || this.collection.options.status === 'archive')
						this.editProject(row.data());
				}, this),
				onGoToProject: _.bind(function (row) {
					this.editProject(row.data());
				}, this),
				onUploadRevision: _.bind(function (row) {
					this.uploadRevision(row.data());
				}, this),
				onChangeReport: _.bind(function (row) {
					this.changeReport(row.data());
				}, this),
				onArchive: _.bind(function (row) {
					this.archiveProject(row.data());
				}, this),
				onDelete: _.bind(function (row) {
					this.deleteProject(row.data());
				}, this),
				onRecycle: _.bind(function (row) {
					this.recycleProject(row.data());
				}, this),
				onRestore: _.bind(function (row) {
					this.restoreProject(row.data());
				}, this),
				settings: this.settings,
				collapsedGroups: this.collapsedGroups
			};

			if (this.settings.get('groupBy')) {
				_.each(this.getColumns(false), _.bind(function (column, index) {
					if (column.columnData === this.settings.get('groupBy'))
						dataTableOptions.orderFixed.push([index, 'asc']);
				}, this));

				dataTableOptions.groupBy = this.settings.get('groupBy');
			}

			if (this.settings.get('orderBy')) {
				_.each(this.getColumns(false), _.bind(function (column, index) {
					if (column.columnData === this.settings.get('orderBy'))
						dataTableOptions.order = [[0,'desc'],[index, this.settings.get('orderAscending') ? 'asc' : 'desc']];
				}, this));
			}

			this.dataTable = new PJQ.views.projects.MyProjectListDataTable(dataTableOptions);
			this.dataTable.$el.on('draw.dt', _.bind(function () {
				this.$('.btn-edit-project, .btn-archive-project, .btn-restore-project, .btn-delete-project, .btn-recycle-project').prop('disabled', this.isMultipleProjectSelectMode);
			}, this));
		}
	},
	getVisibleCustomFieldIds: function () {
		let customFieldIds = _.filter(this.getColumns(false), function (columnDef) {
			return (columnDef.customFieldId);
		});

		customFieldIds = _.map(customFieldIds, function (columnDef) {
			return columnDef.customFieldId;
		});

		return customFieldIds;
	},
	getColumns: function (includeAllColumns = false) {
		let columns = [];

		// favorites column
		if (!includeAllColumns) {
			columns.push({
				"width": "15px",
				"columnData": 'isFavorite',
				"title": '',
				"render": function (data, type, row) {
					if (type === 'sort' || type === 'type')
						return row.attributes.isFavorite;
					return row.attributes.isFavorite ? '<button type="button" class="btn btn-transparent-light btn-favorite-project ml-2" title="Unmark Favorite" data-project-id="' + row.attributes.projectId + '"><i class="fas fa-star text-gold"></i></button>' : '<button type="button" class="btn btn-transparent-light btn-favorite-project ml-2" title="Mark Favorite" data-project-id="' + row.attributes.projectId + '"><i class="far fa-star text-muted"></i></button>';
				},
				"orderable": false,
				"searchable": false,
				"className": "text-center",
				"visible": true
			});

			// multi project select checkbox
			columns.push({
				"width": "15px",
				"columnData": '',
				"data": "attributes.projectId",
				"title": "",
				"orderable": false,
				"searchable": false,
				"render": _.bind(function (data, type, row) {
					let isSelected = false;
					isSelected = _.find(this.getSelectedProjectIds(), function (projectId) {
						return projectId === data;
					}) != null;

					let isDisabled = (PJQ.app.session.get('masterUserId') !== row.attributes.masterUserId);

					return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (isSelected ? ' checked ' : '') + (isDisabled ? ' disabled ' : '') + 'class="select-project"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
				}, this),
				"visible": false
			});
		}

		// core fields
		if (includeAllColumns) {
			columns.push({
				"width": "15px",
				"columnData": "icons",
				"data": null,
				"title": "Icons",
				"visible": this.settings.isColumnSelected("icons"),
				"orderable": false
			});

			if (this.erpIntegration != null) {
				columns.push({
					"width": "15px",
					"columnData": "erpObject",
					"data": null,
					"title": "ERP Status",
					"visible": this.settings.isColumnSelected("erpObject"),
					"orderable": false
				});
			}

			columns.push({
				"columnData": "projectId",
				"data": "attributes.projectId",
				"title": "Project Id",
				"visible": this.settings.isColumnSelected("projectId")
			});
			columns.push({
				"columnData": "projectName",
				"data": "attributes.projectName",
				"title": "Name",
				"visible": this.settings.isColumnSelected("projectName")
			});
			columns.push({
				"columnData": "address1",
				"data": "attributes.address1",
				"title": "Address 1",
				"visible": this.settings.isColumnSelected("address1")
			});
			columns.push({
				"columnData": "address2",
				"data": "attributes.address2",
				"title": "Address 2",
				"visible": this.settings.isColumnSelected("address2")
			});
			columns.push({
				"columnData": "city",
				"data": "attributes.city",
				"title": "City",
				"visible": this.settings.isColumnSelected("city")
			});
			columns.push({
				"columnData": "state",
				"data": "attributes.state",
				"title": "State",
				"visible": this.settings.isColumnSelected("state")
			});
			columns.push({
				"columnData": "zip",
				"data": "attributes.zip",
				"title": "Zip",
				"visible": this.settings.isColumnSelected("zip")
			});
			columns.push({
				"columnData": "created",
				"data": {
					"_": function (row) {
						return new Date(row.attributes.created);
					},
					"filter": "attributes.created",
					"display": function (row) {
						return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.created), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
					}
				},
				"title": "Created",
				"visible": this.settings.isColumnSelected("created")
			});
			columns.push({
				"columnData": 'bidsDue',
				"data": {
					"_": function (row) {

						let dateTemp = new Date();
						if (row.attributes.rDueText === 'ASAP')
							return dateTemp.addDays(-10000);
						if (row.attributes.bidsDue == null)
							return dateTemp.addDays(-20000);

						return new Date(row.attributes.bidsDue);
					},
					"filter": "attributes.bidsDue",
					"display": function (row) {
						if (row.attributes.rDueText === 'ASAP')
							return row.attributes.rDueText;
						if (row.attributes.bidsDue == null)
							return "N/A";

						return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.bidsDue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
					}
				},
				"title": "Bids Due",
				"visible": this.settings.isColumnSelected("bidsDue")
			});

			columns.push({
				"columnData": 'userDisplayName',
				"data": {
					"_": function (row) {
						return (row.attributes.user && row.attributes.user.displayName) ? row.attributes.user.displayName : '';
					}
				},
				"title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) : "Project Contact",
				"visible": this.settings.isColumnSelected("userDisplayName")
			});

			columns.push({
				"columnData": 'user2DisplayName',
				"data": {
					"_": function (row) {
						return (row.attributes.user2 && row.attributes.user2.displayName) ? row.attributes.user2.displayName : '';
					}
				},
				"title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) : "Project Contact 2",
				"visible": this.settings.isColumnSelected("user2DisplayName")
			});

			if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_STATUS_ID)) {
				columns.push({
					"columnData": 'projectStatusId',
					"data": {
						"_": function (row) {
							let st = PJQ.app.session.projectStatuses.get(row.attributes.projectStatusId);
							return st ? st.get('name') : '';
						}
					},
					"title": "Project Status",
					"visible": this.settings.isColumnSelected("projectStatusId")
				});
			}

			columns.push({
				"columnData": "startDate",
				"data": {
					"_": function (row) {
						return new Date(row.attributes.startDate);
					},
					"filter": "attributes.startDate",
					"display": function (row) {
						return row.attributes.startDate ? PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.startDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
					}
				},
				"title": "Start Date",
				"visible": this.settings.isColumnSelected("startDate")
			});

			columns.push({
				"columnData": "endDate",
				"data": {
					"_": function (row) {
						return new Date(row.attributes.endDate);
					},
					"filter": "attributes.endDate",
					"display": function (row) {
						return row.attributes.endDate ? PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.endDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
					}
				},
				"title": "End Date",
				"visible": this.settings.isColumnSelected("endDate")
			});

			_.each(PJQ.app.session.customFields.project[PJQ.app.session.get("masterUserId")].models, _.bind(function (customField) {
				if (customField.get('fieldType') !== 'CONTACT')
					columns.push({
						"columnData": 'fieldValue' + customField.get('fieldNumber'),
						"title": customField.get('fieldName'),
						"render": function (data, type, row) {
							let fieldValue = row.getCustomFieldValue(customField.get('id'));
							fieldValue = fieldValue ? fieldValue : '';
							switch (customField.get('fieldType')) {
								case PJQ.constants.customFields.fieldTypes.TEXT:
									if (fieldValue && type !== 'sort' && type !== 'type') {
										if (PJQ.helpers.urlHelpers.isURL(fieldValue))
											fieldValue = '<a target="_blank" href="' + fieldValue + '">' + fieldValue + '</a>';
									}
									break
								case PJQ.constants.customFields.fieldTypes.DATE:
									if (fieldValue) {
										if (type !== 'sort' && type !== 'type') {
											fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true) || '';
										}
									}
									if (fieldValue === undefined)
										fieldValue = '';

									break;
								case PJQ.constants.customFields.fieldTypes.DATETIME:
									if (fieldValue) {
										if (type !== 'sort' && type !== 'type') {
											fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATETIME, !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_PROJECT_WALL) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.NEW_APP_PORTAL)) || '';
										}
									}
									if (fieldValue === undefined)
										fieldValue = '';
									break;
								case PJQ.constants.customFields.fieldTypes.BOOL:
									if (fieldValue != null)
										fieldValue = fieldValue ? 'Yes' : 'No';
									else
										fieldValue = '';
									break;
								case PJQ.constants.customFields.fieldTypes.CHOICE:
									if (fieldValue) {
										let choices = [];

										// convert single choice value into array so that the logic below can work for both types.
										if (typeof fieldValue === 'number')
											fieldValue = [fieldValue];

										_.each(customField.choices.models, _.bind(function (choice) {
											if (_.find(fieldValue, function (value) {
												return value === choice.get('id');
											}))
												choices.push(choice.get('choiceName'));
										}, this));

										fieldValue = choices.join((', '));
									}
									break;
								case PJQ.constants.customFields.fieldTypes.MONEY:
									if (type === 'sort' || type === 'type') {
										if (fieldValue && fieldValue !== '$')
											fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
										else
											fieldValue = 0;

									}
									break;
							}
							return fieldValue;
						},
						"customFieldId": customField.get('id'),
						"visible": this.settings.isColumnSelected('fieldValue' + customField.get('fieldNumber'))
					});

			}, this));
		}
		else {

			let foundGroupByColumn = false;
			if (!this.settings.get('groupBy'))
				foundGroupByColumn = true;

			_.each(this.settings.get('columns'), _.bind(function (column) {

				if (column === this.settings.get('groupBy'))
					foundGroupByColumn = true;

				this.addColumnHelper(columns, column);
			}, this));

			if (!foundGroupByColumn)
				this.addColumnHelper(columns, this.settings.get('groupBy'), true);

			columns.push({
				"title": '',
				"render": _.bind(function (data, type, row) {
					if (this.options.isAdmin && PJQ.app.session.get('masterUserId') === row.attributes.masterUserId) {
						if (row.attributes.status === 'READY' || row.attributes.status === 'BUSY' || row.attributes.status === 'HIDDEN')
							return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-edit-project ml-1" title="Go to Project"><i class="fal fa-arrow-alt-from-left"></i></button><button type="button" class="btn btn-primary btn-archive-project ml-1" title="Archive Project"><i class="fal fa-archive"></i></button><button type="button" class="btn btn-danger btn-recycle-project ml-1" title="Move Project to Recycle Bin"><i class="fal fa-trash"></i></button></div>';
						else if (row.attributes.status === 'DELETED')
							return '<div class="show-on-row-hover"><button type="button" class="btn btn-primary btn-restore-project ml-1" title="Restore Project"><i class="fal fa-redo"></i></button><button type="button" class="btn btn-danger btn-delete-project ml-1" title="Delete Project PERMANENTLY"><i class="fal fa-trash"></i></button></div>';
						else
							return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-edit-project ml-1" title="Go to Project"><i class="fal fa-arrow-alt-from-left"></i></button><button type="button" class="btn btn-primary btn-restore-project ml-1" title="Restore Project"><i class="fal fa-redo"></i></button><button type="button" class="btn btn-danger btn-recycle-project ml-1" title="Move Project to Recycle Bin"><i class="fal fa-trash"></i></button></div>';
					}
					else {
						return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-edit-project ml-1" title="Go to Project"><i class="fal fa-arrow-alt-from-left"></i></button>';
					}
				}, this),
				"orderable": false,
				"searchable": false,
				"width": "120px",
				"className": "text-center",
				"visible": true
			});
		}

		return columns;
	},
	addColumnHelper: function (columns, column, notVisible) {
		let visible = true;
		if (notVisible)
			visible = false;

		switch (column) {
			case 'icons':
				columns.push({
					"columnData": "icons",
					"data": null,
					"title": "",
					"visible": visible,
					"orderable": false,
					"render": function (data, type, row) {
						return row.attributes.projectMessageCount === 0 ? '' : '<img src="/assets/modules2/global/images/resend.png" border="0" title="Project Messages have been sent." />';
					}
				});
				break;
			case 'erpObject':
				if (this.erpIntegration != null) {
					columns.push({
						"columnData": "erpObject",
						"data": null,
						"title": "ERP",
						"visible": visible,
						"orderable": false,
						"width": 100,
						"render": function (data, type, row) {
							let exObj = row.get('externalObject');
							if (exObj == null) {
								return '';
							}

							if (type === 'sort' || type === 'type') {
								return exObj.data?.externalNumber ?? "";
							}
							return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
						}
					});
				}
				break;
			case 'projectId':
				columns.push({
					"columnData": "projectId",
					"data": "attributes.projectId",
					"title": "Project Id",
					"visible": visible,
					"orderable": (this.settings.get('groupBy') !== 'projectId')
				});
				break;
			case 'projectName':
				columns.push({
					"columnData": "projectName",
					"data": "attributes.projectName",
					"title": "Name",
					"visible": visible,
					"orderable": (this.settings.get('groupBy') !== 'projectName'),
					"render": _.bind(function (data, type, row) {
						return "<a href='#/projects/" + row.attributes.projectId + "'>" + row.attributes.projectName + '</a>';
					}, this)
				});
				break;
			case 'address1':
				columns.push({
					"columnData": "address1",
					"data": "attributes.address1",
					"title": "Address 1",
					"visible": visible,
					"orderable": (this.settings.get('groupBy') !== 'address1')
				});
				break;
			case 'address2':
				columns.push({
					"columnData": "address2",
					"data": "attributes.address2",
					"title": "Address 2",
					"visible": visible,
					"orderable": (this.settings.get('groupBy') !== 'address2')
				});
				break;
			case 'city':
				columns.push({
					"columnData": "city",
					"data": "attributes.city",
					"title": "City",
					"visible": visible,
					"orderable": (this.settings.get('groupBy') !== 'city')
				});
				break;
			case 'state':
				columns.push({
					"columnData": "state",
					"data": "attributes.state",
					"title": "State",
					"visible": visible,
					"orderable": (this.settings.get('groupBy') !== 'state')
				});
				break;
			case 'zip':
				columns.push({
					"columnData": "zip",
					"data": "attributes.zip",
					"title": "Zip",
					"visible": visible,
					"orderable": (this.settings.get('groupBy') !== 'zip')
				});
				break;
			case 'created':
				columns.push({
					"columnData": "created",
					"data": {
						"_": function (row) {
							return new Date(row.attributes.created);
						},
						"filter": "attributes.created",
						"display": function (row) {
							return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.created), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
						}
					},
					"title": "Created",
					"visible": visible,
					"orderable": (this.settings.get('groupBy') !== 'created')
				});
				break;
			case 'bidsDue':
				columns.push({
					"columnData": 'bidsDue',
					"orderable": (this.settings.get('groupBy') !== 'bidsDue'),
					"data": {
						"_": function (row) {

							let dateTemp = new Date();
							if (row.attributes.bidsDue == null)
								return dateTemp.addDays(-20000);
							if (row.attributes.rDueText === 'ASAP')
								return dateTemp.addDays(-10000);

							return new Date(row.attributes.bidsDue);
						},
						"filter": "attributes.bidsDue",
						"display": function (row) {
							if (row.attributes.rDueText === 'ASAP')
								return row.attributes.rDueText;
							if (row.attributes.bidsDue == null)
								return "N/A";

							return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.bidsDue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
						}
					},
					"title": "Bids Due", "visible": visible
				});
				break;
			case 'userDisplayName':
				columns.push({
					"columnData": 'userDisplayName',
					"data": {
						"_": function (row) {
							return (row.attributes.user && row.attributes.user.displayName) ? row.attributes.user.displayName : '';
						}
					},
					"title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) : "Project Contact",
					"visible": visible
				});
				break;
			case 'user2DisplayName':
				columns.push({
					"columnData": 'user2DisplayName',
					"data": {
						"_": function (row) {
							return (row.attributes.user2 && row.attributes.user2.displayName) ? row.attributes.user2.displayName : '';
						}
					},
					"title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) : "Project Contact 2",
					"visible": visible
				});
				break;
			case 'projectStatusId':
				columns.push({
					"columnData": 'projectStatusId',
					"data": {
						"_": function (row) {
							let st = PJQ.app.session.projectStatuses.get(row.attributes.projectStatusId);
							return st ? st.get('name') : '';
						}
					},
					"title": "Project Status",
					"visible": visible
				});
				break;
			case 'startDate':
				columns.push({
					"columnData": "startDate",
					"data": {
						"_": function (row) {
							return new Date(row.attributes.startDate);
						},
						"filter": "attributes.startDate",
						"display": function (row) {
							return row.attributes.startDate ? PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.startDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
						}
					},
					"title": "Start Date",
					"visible": visible
				});
				break;
			case 'endDate':
				columns.push({
					"columnData": "endDate",
					"data": {
						"_": function (row) {
							return new Date(row.attributes.endDate);
						},
						"filter": "attributes.endDate",
						"display": function (row) {
							return row.attributes.endDate ? PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.endDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
						}
					},
					"title": "End Date",
					"visible": visible
				});
				break;
			default:
				if (column.startsWith('fieldValue')) {
					// Project Custom Fields
					_.each(PJQ.app.session.customFields.project[PJQ.app.session.get("masterUserId")].models, _.bind(function (customField) {
						// todo: only show the ones the user wants to.
						if (column === 'fieldValue' + customField.get('fieldNumber'))
							columns.push({
								"columnData": 'fieldValue' + customField.get('fieldNumber'),
								"orderable": (this.settings.get('groupBy') !== 'fieldValue' + customField.get('fieldNumber')),
								"title": customField.get('fieldName'),
								"render": function (data, type, row) {
									let fieldValue = row.getCustomFieldValue(customField.get('id'));
									fieldValue = fieldValue ? fieldValue : '';
									switch (customField.get('fieldType')) {
										case PJQ.constants.customFields.fieldTypes.TEXT:
											if (fieldValue && type !== 'sort' && type !== 'type') {
												if (PJQ.helpers.urlHelpers.isURL(fieldValue))
													fieldValue = '<a target="_blank" href="' + fieldValue + '">' + fieldValue + '</a>';
											}
											break
										case PJQ.constants.customFields.fieldTypes.DATE:
											if (fieldValue) {
												if (type !== 'sort' && type !== 'type')
													fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
											}
											if (fieldValue === undefined)
												fieldValue = '';
											break;
										case PJQ.constants.customFields.fieldTypes.DATETIME:
											if (fieldValue) {
												if (type !== 'sort' && type !== 'type')
													fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_PROJECT_WALL) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.NEW_APP_PORTAL));
											}
											if (fieldValue === undefined)
												fieldValue = '';
											break;
										case PJQ.constants.customFields.fieldTypes.BOOL:
											if (fieldValue != null)
												fieldValue = fieldValue ? 'Yes' : 'No';
											else
												fieldValue = '';
											break;
										case PJQ.constants.customFields.fieldTypes.CHOICE:
											if (fieldValue) {
												let choices = [];

												// convert single choice value into array so that the logic below can work for both types.
												if (typeof fieldValue === 'number')
													fieldValue = [fieldValue];

												_.each(customField.choices.models, _.bind(function (choice) {
													if (_.find(fieldValue, function (value) {
														return value === choice.get('id');
													}))
														choices.push(choice.get('choiceName'));
												}, this));

												fieldValue = choices.join((', '));
											}
											break;
										case PJQ.constants.customFields.fieldTypes.MONEY:
											if (type === 'sort' || type === 'type') {
												if (fieldValue && fieldValue !== '$')
													fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
												else
													fieldValue = 0;

											}
											else {
												fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
											}
											break;
										case PJQ.constants.customFields.fieldTypes.INT:
											if (type !== 'sort' && type !== 'type' && fieldValue) {
												fieldValue = parseInt(fieldValue).toLocaleString();
											}
											break;
									}

									return fieldValue;
								},
								"customFieldId": customField.get('id'),
								"visible": visible
							});

					}, this));
				}
				break;
		}

	},
	editProjectButton: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
		this.editProject(row.data())
	},
	editProject: function (project) {
		if (PJQ.app.session.get('masterUserId') === project.attributes.masterUserId || PJQ.app.module === PJQ.constants.modules.APP) {
			window.pjqProjectId = project.id.toString();
			window.pjqWallContext = 'project';
			window.pjqIsNewProject = false;
			PJQ.app.router.navigate('projects/' + project.id.toString(), {
				trigger: true
			});
		}
		else {
			window.location.href = '/Default.aspx?tabId=' + PJQ.app.session.preferences.getPref('projectWallSubTabId') + '&key=' + project.attributes.accessKey;
		}
	},
	newProject: function () {
		if (PJQ.app.module === PJQ.constants.modules.APP) {

			let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'new'
				}
			]);
			new PJQ.ajax.Request({
				endpoint: endpoint
			}).post().done(_.bind(function (project) {
				PJQ.app.router.navigate('projects/' + project.projectId.toString() + '/details', {
					trigger: true
				});
			}, this)).fail(function () {
			});

			/*
			new PJQ.views.projects.NewProjectModal({
				onSave: function (project) {
					window.pjqProjectId = 0;
					window.pjqWallContext = 'project';
					window.pjqIsNewProject = true;
					PJQ.app.router.navigate('projects/' + project.id.toString() + '/details', {
						trigger: true
					});
				}
			});

			 */
		}
		else {
			window.pjqProjectId = 0;
			window.pjqWallContext = 'project';
			window.pjqIsNewProject = true;
			PJQ.app.router.navigate('projects/0', {
				trigger: true
			});
		}
	},
	archiveProjectButton: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
			project = row.data();
		this.archiveProject(project);
	},
	archiveProject: function (project) {
		let projectNameString = (_.size(project.get('projectName')) > 0 ? ('<b>' + project.get('projectName') + '</b>') : 'this project'),
			archiveText = 'Are you sure you want to archive ' + projectNameString + '?';

		new PJQ.views.BaseModal({
			header: "Confirm Archive",
			okButtonText: 'Archive',
			body: archiveText,
			isShowCancelButton: true,
			onOk: _.bind(function () {
				this.archiveProjectList([project.id]);
			}, this)
		});
	},
	archiveProjectList: function (ids) {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'archive'
			}
		], [
			{
				parameter: "projects",
				value: ids
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function () {
			_.each(ids, _.bind(function (id) {
				this.dataTable.dataTable
					.row($('.btn-favorite-project[data-project-id="' + id.toString() + '"]').closest('tr'))
					.remove()
					.draw();
			}, this));
		}, this)).fail(function () {
		});
	},
	restoreProjectButton: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
			project = row.data();
		this.restoreProject(project);

	},
	restoreProject: function (project) {
		let projectNameString = (_.size(project.get('projectName')) > 0 ? ('<b>' + project.get('projectName') + '</b>') : 'this project'),
			restoreText = 'Are you sure you want to restore ' + projectNameString + '?';

		new PJQ.views.BaseModal({
			header: "Confirm Restore",
			body: restoreText,
			isShowCancelButton: true,
			onOk: _.bind(function () {
				this.restoreProjectList([project.id]);
			}, this)
		});
	},
	restoreProjectList: function (ids) {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'restore'
			}
		], [
			{
				parameter: "projects",
				value: ids
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function () {
			_.each(ids, _.bind(function (id) {
				this.dataTable.dataTable
					.row($('.btn-favorite-project[data-project-id="' + id.toString() + '"]').closest('tr'))
					.remove()
					.draw();
			}, this));
		}, this)).fail(function () {
		});
	},
	recycleProjectButton: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
			project = row.data();
		this.recycleProject(project);
	},
	deleteProjectButton: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
			project = row.data();
		this.deleteProject(project);
	},
	recycleProject: function (project) {
		let projectNameString = (_.size(project.get('projectName')) > 0 ? ('<b>' + project.get('projectName') + '</b>') : 'this project'),
			deleteText = this.dataTable.getStatusFilter() === 'deleted' ? 'Are you sure you want to PERMANENTLY DELETE ' + projectNameString + '?' : 'Are you sure you want to move ' + projectNameString + ' to the Recycle Bin?';

		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: deleteText,
			onDelete: _.bind(function () {
				this.recycleProjectList([project.id]);
			}, this)
		});
	},
	deleteProject: function (project) {
		let projectNameString = (_.size(project.get('projectName')) > 0 ? ('<b>' + project.get('projectName') + '</b>') : 'this project'),
			deleteText = this.dataTable.getStatusFilter() === 'deleted' ? 'Are you sure you want to PERMANENTLY DELETE ' + projectNameString + '?' : 'Are you sure you want to move ' + projectNameString + ' to the Recycle Bin?';

		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: deleteText,
			onDelete: _.bind(function () {
				this.deleteProjectList([project.id]);
			}, this)
		});
	},
	recycleProjectList: function (ids) {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'recycle'
			}
		], [
			{
				parameter: "projects",
				value: ids
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function () {
			_.each(ids, _.bind(function (id) {
				this.dataTable.dataTable
					.row($('.btn-favorite-project[data-project-id="' + id.toString() + '"]').closest('tr'))
					.remove()
					.draw();
			}, this));
		}, this)).fail(function () {
		});
	},
	deleteProjectList: function (ids) {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'deleterecycle'
			}
		], [
			{
				parameter: "projects",
				value: ids
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function () {
			_.each(ids, _.bind(function (id) {
				this.dataTable.dataTable
					.row($('.btn-favorite-project[data-project-id="' + id.toString() + '"]').closest('tr'))
					.remove()
					.draw();
			}, this));
		}, this)).fail(function () {
		});
	},
	favoriteProject: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
			project = row.data();
		this.favoriteProjectList([project.id], !project.get('isFavorite'));
	},
	favoriteProjectList: function (ids, isFavorite) {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'favorites'
			}
		], [
			{
				parameter: "projects",
				value: ids
			},
			{
				parameter: "isFavorite",
				value: isFavorite
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function () {
			_.each(ids, _.bind(function (id) {
				_.each(this.dataTable.options.collection.models, function (row) {
					if (row.attributes.projectId === id)
						row.attributes.isFavorite = isFavorite;
				}, this);

				let $favoriteButton = $('.btn-favorite-project[data-project-id="' + id + '"] i');
				if (isFavorite) {
					$favoriteButton.removeClass('far').addClass(('fas'));
					$favoriteButton.removeClass('text-muted').addClass(('text-gold'));
				}
				else {
					$favoriteButton.removeClass('fas').addClass(('far'));
					$favoriteButton.removeClass('text-gold').addClass(('text-muted'));
				}
			}, this));
		}, this)).fail(function () {
		});

	},
	multipleProjectActionInitialize: function (sender) {

		// label the primary action button
		this.$('.projects-action-confirm').text($(sender.currentTarget).text());

		// track which mode we're in
		this.multipleProjectMode = $(sender.currentTarget).prop('className').replace('dropdown-item ', '');

		// show the action buttons
		this.$('.projects-action-confirm').prop('disabled', true);
		this.$('.btn-other-project-actions').parent().hide();
		this.$('.projects-action-confirm, .projects-action-cancel').show();

		// clear existing selections
		this.selectedProjects = [];
		this.dataTable.dataTable.rows().invalidate().draw(false);

		// disable all other header controls
		this.$('.btn-new-project, .btn-other-project-actions, .btn-edit-project, .btn-archive-project, .btn-restore-project, .btn-delete-project, .btn-recycle-project, .project-list-status-filter').prop('disabled', true);
		this.$('.filter-option').addClass('text-muted');

		// show the checkbox column
		this.dataTable.dataTable.column(1).visible(true);
		this.dataTable.refresh();

		this.isMultipleProjectSelectMode = true;
	},
	multipleProjectSelection: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
			project = row.data();
		if ($(e.currentTarget).prop('checked')) {
			this.selectedProjects.push(project);
		}
		else {
			this.selectedProjects = _.filter(this.selectedProjects, function (sp) {
				return sp.id !== project.id
			});
		}

		this.$('.projects-action-confirm').prop('disabled', _.size(this.selectedProjects) === 0);
	},
	multipleProjectActionConfirm: function () {

		if (this.multipleProjectMode === 'invite-projects') {
			this.projectInvites();
			return;
		}
		let actionText = '';
		switch (this.multipleProjectMode) {
			case 'favorite-projects':
				actionText = 'Are you sure you want to mark ' + _.size(this.selectedProjects) + ' Projects as Favorites?';
				break;
			case 'unfavorite-projects':
				actionText = 'Are you sure you want to unmark ' + _.size(this.selectedProjects) + ' Projects as Favorites?';
				break;
			case 'archive-projects':
				actionText = 'Are you sure you want to archive ' + _.size(this.selectedProjects) + ' Projects?';
				break;
			case 'restore-projects':
				actionText = 'Are you sure you want to restore ' + _.size(this.selectedProjects) + ' Projects?';
				break;
			case 'delete-projects':
				actionText = this.dataTable.getStatusFilter() === 'deleted' ? 'Are you sure you want to PERMANENTLY DELETE ' + _.size(this.selectedProjects) + ' Projects?' : 'Are you sure you want to move ' + _.size(this.selectedProjects) + ' Projects to the Recycle Bin?';
				break;
		}

		new PJQ.views.BaseModal({
			header: "Confirm Action",
			body: actionText,
			isShowCancelButton: true,
			onOk: _.bind(function () {
				switch (this.multipleProjectMode) {
					case 'favorite-projects':
						this.favoriteProjectList(this.getSelectedProjectIds(), true);
						break;
					case 'unfavorite-projects':
						this.favoriteProjectList(this.getSelectedProjectIds(), false);
						break;
					case 'archive-projects':
						this.archiveProjectList(this.getSelectedProjectIds());
						break;
					case 'restore-projects':
						this.restoreProjectList(this.getSelectedProjectIds());
						break;
					case 'delete-projects':
						if (this.dataTable.getStatusFilter() === 'deleted') {
							this.deleteProjectList(this.getSelectedProjectIds());
						}
						else {
							this.recycleProjectList(this.getSelectedProjectIds());
						}
						break;
				}
				this.multipleProjectActionCancel();
			}, this)
		});
	},
	getSelectedProjectIds: function () {
		return _.map(this.selectedProjects, function (project) {
			return project.id;
		});
	},
	multipleProjectActionCancel: function () {
		// hide the action buttons
		this.$('.projects-action-confirm, .projects-action-cancel').hide();
		this.$('.btn-other-project-actions').parent().show();

		// hide the checkbox column
		this.dataTable.dataTable.column(1).visible(false);

		// enable all other header controls
		this.$('.btn-new-project, .btn-other-project-actions, .btn-edit-project, .btn-archive-project, .btn-restore-project, .btn-delete-project, .btn-recycle-project, .project-list-status-filter').prop('disabled', false);
		this.$('.filter-option').removeClass('text-muted');

		this.isMultipleProjectSelectMode = false;
	},
	settings: function () {
		new PJQ.views.projects.MyProjectListSettingsModal({
			columns: this.getColumns(true),
			settings: this.settings,
			onSave: _.bind(function () {
				this.collection = new PJQ.collections.projects.Projects(null, {
					isSimple: false,
					status: 'ready',
					customFieldIds: this.getVisibleCustomFieldIds()
				});
				this.collection.fetch({
					success: _.bind(function () {
						this.isFetched = true;
						this.render();
					}, this)
				});
			}, this)
		});
	},
	projectInvites: function () {
		new PJQ.views.projectInvites.ProjectInvitesModal({
			projects: this.selectedProjects,
			emailTemplates: PJQ.app.session.emailTemplates.projectMessage.models,
			onSend: _.bind(function () {
				this.multipleProjectActionCancel();
			}, this),
			onClose: _.bind(function () {
				this.multipleProjectActionCancel();
			}, this)
		});
	},
	uploadRevision: function (project) {
		new PJQ.views.files.RawFileUploaderModal({
			project: project
		});
	},
	changeReport: function (project) {
		PJQ.files.downloadFile(
			PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: project.id
				},
				{
					endpoint: 'changereport'
				}
			])
		);
	}
});

PJQ.views.projects.NewProjectModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTLIST, 'Modal-New-Project'),
		minWidth: '500px',
		onSave: _.noop
	},
	events: {
		'keyup .input-project-name': 'projectNameChanged',
		'click .btn-save-project': 'onSave'
	},
	beforeModalCreated: function () {
		this.model = new PJQ.models.projects.Project();
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		this.$('.input-project-name').focus();
	},
	projectNameChanged: function (e) {
		let projectName = this.$('.input-project-name').val(),
			projectNameBlank = _.size(projectName) === 0;
		this.$('.btn-save-project').prop('disabled', projectNameBlank);
		if (!projectNameBlank && e.keyCode === 13) {
			this.onSave();
		}
	},
	onSave: function () {
		let projectName = this.$('.input-project-name').val();
		if (_.size(projectName) === 0) {
			return;
		}

		new PJQ.Loader(this.$('.modal-content'));
		this.model.save({
			projectName: projectName
		}, {
			success: _.bind(function () {
				this.removeModal();
				if (typeof this.options.onSave === 'function') {
					this.options.onSave(this.model);
				}
			}, this)
		});
	}
});

PJQ.views.projects.MyProjectListSettingsModal = PJQ.views.BaseModal.extend({
	defaults: {
		columns: [],
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTLIST, 'Project-List-Settings'),
		minWidth: '40%',
		onSave: _.noop,
		settings: null
	},
	events: {
		'click .settings-close': 'removeModal',
		'click .settings-save': 'onSave',
		'change .select-column': 'columnSelected'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		// iterate through columns and build GroupBy dropdown.
		_.each(this.options.columns, _.bind(function (column) {
			this.$('select.grouping').append('<option value="' + column.columnData + '" >' + column.title + '</option>');
		}, this));

		new PJQ.inputs.Selectpicker({
			el: this.$('select.rows-per-page'),
			defaultValue: this.options.settings.get('rowsPerPage')
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('select.grouping'),
			defaultValue: this.options.settings.get('groupBy')
		});

		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.column-settings'),
			data: this.options.columns,
			isHideSearch: true,
			order: [],
			columns: [
				{"data": "title", "title": "Column", "orderable": false},
				{
					"data": "visible",
					"title": "Show",
					"orderable": false,
					"searchable": false,
					"render": _.bind(function (data) {
						return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
					}, this),
					"width": '10%'
				}
			],
			dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'

		});
	},
	onSave: function () {
		this.options.settings.set('rowsPerPage', parseInt(this.$('select.rows-per-page').val()));
		this.options.settings.set('groupBy', this.$('select.grouping').val());

		// todo: column settings.
		_.each(this.dataTable.options.data, _.bind(function (column) {
			let columns = this.options.settings.get('columns');
			if (column.visible) {
				// add to end if missing
				if (_.find(columns, function (col) {
					return col === column.columnData
				}) === undefined)
					columns.push(column.columnData);
			}
			else {
				// remove if present
				columns = _.filter(columns, function (col) {
					return col !== column.columnData;
				});
			}
			this.options.settings.set('columns', columns);
		}, this));

		this.options.settings.save();

		if (this.options.onSave) {
			this.options.onSave(this.model);
		}
		this.removeModal();
	},
	columnSelected: function (sender) {
		this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
	}
});
